import type { ReactElement } from 'react';

import { Card, Flex, Skeleton } from '@rango-dev/whale';
import React from 'react';

import styles from './TopUserCard.module.css';

export function CompactTopUserCardSkeleton(): ReactElement {
  return (
    <Card size="1" variant="surface" className={styles.compactCard}>
      <Flex direction="column" align="center" gap="2" py="4" px="2" alignSelf="stretch">
        <Skeleton width="64px" height="64px" />
        <Skeleton width="32px" height="28px" />
        <Skeleton width="80px" height="16px" />
        <Skeleton width="80px" height="24px" />
      </Flex>
    </Card>
  );
}
